﻿let form;

export function initializeDebtorDetailsIncome() {
    initializeDynamicList('income-details-container', 'data-add-income', 'data-remove-income');
    initializeDynamicList('financial-obligations-container', 'data-add-obligation', 'data-remove-obligation');
}

function initializeDynamicList(containerId, addAttribute, removeAttribute) {
    const container = document.getElementById(containerId);
    form = document.querySelector('form');

    if (!container || !form) return;

    const handler = createClickHandler(container, addAttribute, removeAttribute);

    container.removeEventListener('click', handler);
    container.addEventListener('click', handler);
}

function createClickHandler(container, addAttribute, removeAttribute) {
    return function handleContainerClick(event) {
        const button = event.target.closest(`[${addAttribute}], [${removeAttribute}]`);

        if (!button || !container.contains(button)) return;

        if (button.hasAttribute(addAttribute)) {
            event.preventDefault();
            handleAdd(button, container);
            return;
        }

        if (button.hasAttribute(removeAttribute)) {
            event.preventDefault();
            handleRemove(button, container, removeAttribute);
        }
    };
}

async function handleAdd(button, container) {
    const formData = new FormData(form);
    const actionUrl = button.dataset.actionUrl;

    if (!actionUrl) {
        console.error('Missing data-action-url attribute on button');
        return;
    }

    await postAndRefresh(actionUrl, formData, container);
}

async function handleRemove(button, container, removeAttribute) {
    const formData = new FormData(form);
    const index = button.getAttribute(removeAttribute);
    const indexParamName = removeAttribute.replace('data-remove-', '') + 'Index';

    formData.append(indexParamName, index);

    const actionUrl = button.dataset.actionUrl;

    if (!actionUrl) {
        console.error('Missing data-action-url attribute on button');
        return;
    }

    await postAndRefresh(actionUrl, formData, container);
}

async function postAndRefresh(actionUrl, formData, container) {
    try {
        const response = await fetch(actionUrl, {
            method: 'POST',
            body: formData
        });

        if (!response.ok) {
            throw new Error('Server error');
        }

        const html = await response.text();
        container.innerHTML = html;
        reparseValidation();
    }
    catch (error) {
        console.error('Error updating list:', error);
    }
}

function reparseValidation() {
    if (!window.jQuery || !window.jQuery.validator || !window.jQuery.validator.unobtrusive) {
        return;
    }

    const $form = window.jQuery(form);
    $form.removeData('validator');
    $form.removeData('unobtrusiveValidation');
    window.jQuery.validator.unobtrusive.parse(form);
}